import React from 'react'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'
import { WebsiteLogoTextUi, WebsiteLogoWrapperUi } from './ui'
import { WebsiteLogoPicture } from './website-logo-picture'

interface WebsiteLogoProps extends WebsiteLogoInterface {
  imageSrc: string
  mobileImageSrc: string
  alt?: string
}

export const CommonWebsiteLogo = (props: WebsiteLogoProps) => {
  return (
    <WebsiteLogoWrapperUi id={props.htmlAttrId}>
      <WebsiteLogoTextUi
        {...props}
        color={props.textColor}
        imageSrc={props.imageSrc}
        mobileImageSrc={props.mobileImageSrc}
      >
        {props.logoText}
      </WebsiteLogoTextUi>

      <WebsiteLogoPicture
        alt={props.alt ?? props.logoText ?? ''}
        imageSrc={props.imageSrc}
        mobileImageSrc={props.mobileImageSrc}
        height={props.height}
        mobileHeight={props.mobileHeight || props.height}
      />
    </WebsiteLogoWrapperUi>
  )
}
